import { render, staticRenderFns } from "./ListAlaModal.vue?vue&type=template&id=e1c93a54"
import script from "./ListAlaModal.vue?vue&type=script&lang=js"
export * from "./ListAlaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports